










import { defineComponent, PropType } from 'vue';
import { useGroupFilter } from '../../composables/documents/useGroupFilter';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import AulaMultiselect from '../../../shared/components/select/AulaMultiselect.vue';

export default defineComponent({
  name: 'DocumentGroupFilter',
  components: { AulaMultiselect },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: { type: Array as PropType<number[] | string[]>, default: () => [] },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const { groupOptions } = useGroupFilter();

    const emitChange = groupIds => {
      emit('change', groupIds);
    };

    return {
      groupOptions,
      emitChange,
      iconClassEnum,
    };
  },
});
